export default __webpack_public_path__ + "static/media/flights.c15f7059.jpeg";